import React, {Component} from 'react';
import _ from 'lodash';
import './style.css';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import { routeActions } from 'react-router-redux';
import { actions as meActions } from 'modules/me';
import { Row, Col, Icon, Tooltip, Badge, message } from 'antd';
import { logAsync } from 'helpers/elogAsync';

const container = connect(
  createSelector(
    (state) => ({
      navBarSubjectLabel: _.get(state, 'subject.navBarSubjectLabel'),
      subjects: _.get(state, 'subject.entities'),
      clipping: _.get(state, 'collection.globalIds'),
      permission: _.get(state, 'me.permission'),
      user: _.get(state, 'me'),
    }),
    (state) => ({
      ...state
    })
  )
)

class Bar extends Component {
  render() {
    const {navBarSubjectLabel, subjects, clipping, dispatch, permission, user} = this.props;
    const {register_email} = localStorage;
    return (
      <div className="header-bar">
        <Tooltip placement="bottom" title="首頁">
          <Link to='/'>
            <i className="mediaType-icon hone-gray-icon" ></i>
          </Link>
        </Tooltip>
        {_.map(_.get(navBarSubjectLabel, 'data'), (subjectId) => {
          const subject = subjects[subjectId]
          return (
            <Link to={`/search?subjectId=${subjectId}`} key={subjectId}>
              <div className="bar-subject"
                onClick={() => {
                  logAsync({
                    type: "sPOP-click-subject",
                    data: {
                      subjectId: subjectId,
                      url: window.location.href,
                      user: register_email,
                    }
                  })
                }}>
                {_.get(subject, 'name')}
              </div>
            </Link>
          )
          })
        }
        <div className="pull-right margin-right-lg">
          <div className="pull-right margin-left-lg" >
            <a
              style={{display: "inline-block"}}
              onClick={() => {
                logAsync({
                  type: "sPOP-quit",
                  data: {
                    url: window.location.href,
                    user: register_email
                  }
                })
                localStorage.clear();
                location.replace('/login.html');
              }}>
              <Tooltip placement="bottom" title={t('commonQuit')}>
                <i className="mediaType-icon logout-icon-gray"></i>
              </Tooltip>
            </a>
          </div>
          <div className="pull-right margin-left-lg" >
            <Tooltip placement="bottom" title="收藏夾">
              <Badge
                onClick={() => {
                  dispatch(routeActions.push({pathname: '/collection'}))
                  .then(() => {
                    logAsync({
                      type: "sPOP-click-collection",
                      data: {
                        url: window.location.href,
                        user: register_email
                      }
                    })
                  })
                }}
                className="cursor-pointer"
                count={clipping.length}
                overflowCount={99}
              >
                <a><i className="mediaType-icon collection-icon-gray"></i></a>
              </Badge>
            </Tooltip>
          </div>
          {false &&
            <div className="pull-right margin-left-lg" >
              <Tooltip placement="bottom" title="個人中心">
                <a
                  style={{display: "inline-block"}}
                  onClick={() => {
                    if (_.get(permission, 'favoriteQuota.enabled')) {
                      dispatch(routeActions.push({pathname: '/me'}))
                      .then(() => {
                        logAsync({
                          type: "sPOP-click-me",
                          data: {
                            url: window.location.href,
                            user: register_email
                          }
                        })
                      })
                    } else {
                      dispatch(routeActions.push({pathname: '/login'}))
                    }
                  }}>
                  <i className="mediaType-icon person-icon-gray"></i>
                </a>
              </Tooltip>
            </div>
          }
          <div className="pull-right margin-left-lg" >
            <span className="use-name">您好，{user.username}</span>
          </div>
        </div>
      </div>
    )
  }
}

export default container(Bar)



/** WEBPACK FOOTER **
 ** ./src/app/modules/header/components/Bar.js
 **/